import React from 'react';

const RecruitmentBenefitsCategory = React.lazy(() =>
  import('pages/RecruitmentBenefitsCategory/RecruitmentBenefitsCategory'),
);
const RecruitmentBenefitsCategoryAdd = React.lazy(() =>
  import('pages/RecruitmentBenefitsCategory/RecruitmentBenefitsCategoryAdd'),
);
const RecruitmentBenefitsCategoryEdit = React.lazy(() =>
  import('pages/RecruitmentBenefitsCategory/RecruitmentBenefitsCategoryEdit'),
);
const RecruitmentBenefitsCategoryDetail = React.lazy(() =>
  import('pages/RecruitmentBenefitsCategory/RecruitmentBenefitsCategoryDetail'),
);

const recruitmentBenefitsCategoryRoutes = [
  {
    path: '/recruitment-benefits-category',
    exact: true,
    name: 'Danh sách danh mục',
    function: 'RECRUITMENT_BENEFITS_CATEGORY_VIEW',
    component: RecruitmentBenefitsCategory,
  },
  {
    path: '/recruitment-benefits-category/add',
    exact: true,
    name: 'Thêm mới danh mục',
    function: 'RECRUITMENT_BENEFITS_CATEGORY_ADD',
    component: RecruitmentBenefitsCategoryAdd,
  },
  {
    path: '/recruitment-benefits-category/detail/:id',
    exact: true,
    name: 'Chi tiết danh mục',
    function: 'RECRUITMENT_BENEFITS_CATEGORY_VIEW',
    component: RecruitmentBenefitsCategoryDetail,
  },
  {
    path: '/recruitment-benefits-category/edit/:id',
    exact: true,
    name: 'Chỉnh sửa danh mục',
    function: 'RECRUITMENT_BENEFITS_CATEGORY_EDIT',
    component: RecruitmentBenefitsCategoryEdit,
  },
];

export default recruitmentBenefitsCategoryRoutes;
